export default __webpack_public_path__ + "images/6071f35cfcd246ade7954fd806fd015b.svg";